// extracted by mini-css-extract-plugin
export default {"container":"choose_container__Bq9sp","flexBox":"choose_flexBox__-h3SN"};